import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ConceptModel } from 'src/app/models/management/concept.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConceptService {

  constructor(private _httpClient: HttpClient) { }

  createConcept(conceptContractModel: ConceptModel): Observable<ConceptModel> {
    return this._httpClient.post<ConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concept.CreateConcept}`,
      conceptContractModel);
  }

  deleteConcept(conceptId: number): Observable<ConceptModel> {
    return this._httpClient.delete<ConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concept.DeleteConcept}/${conceptId}`);
  }

  getAllConceptNoteStagesForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concept.GetAllConceptNoteStagesForSelectAsync}`,);
  }

  getAllConceptsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concept.GetAllConceptsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getAllTypeConceptsForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concept.GetAllTypeConceptsForSelectAsync}`,);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concept.GetColumnsForGeneralConsultationAsync}`);
  }

  getConceptByCode(typeConceptId: number, code: number): Observable<ConceptModel> {
    return this._httpClient.get<ConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concept.GetConceptByCode}/${typeConceptId}/${code}`)
  }

  getConceptById(conceptId: number): Observable<ConceptModel> {
    return this._httpClient.get<ConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concept.GetConceptById}/${conceptId}`)
  }

  getConceptEntry(): Observable<Array<ConceptModel>> {
    return this._httpClient.get<Array<ConceptModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concept.GetConceptEntry}`)
  }

  getConceptOutput(): Observable<Array<ConceptModel>> {
    return this._httpClient.get<Array<ConceptModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concept.GetConceptOutput}`)
  }

  getConceptsAnnul(): Observable<Array<ConceptModel>> {
    return this._httpClient.get<Array<ConceptModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concept.GetConceptsAnnul}`)
  }

  getConceptsBussinesType(): Observable<Array<ConceptModel>> {
    return this._httpClient.get<Array<ConceptModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concept.GetConceptsBussinesType}`)
  }

  getConceptsBussinesType2(): Observable<Array<ConceptModel>> {
    return this._httpClient.get<Array<ConceptModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concept.GetConceptsBussinesType2}`)
  }

  getConceptsCreditNote(): Observable<Array<ConceptModel>> {
    return this._httpClient.get<Array<ConceptModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concept.GetConceptsCreditNote}`)
  }

  getConceptsDebitNote(): Observable<Array<ConceptModel>> {
    return this._httpClient.get<Array<ConceptModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concept.GetConceptsDebitNote}`)
  }

  getConceptsTypeEquipment(): Observable<Array<ConceptModel>> {
    return this._httpClient.get<Array<ConceptModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concept.GetConceptsTypeEquipment}`)
  }

  getConceptsVehicleType(): Observable<Array<ConceptModel>> {
    return this._httpClient.get<Array<ConceptModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concept.GetConceptsVehicleType}`)
  }

  getFirstConceptByKeysAsync(typeConceptId: number): Observable<ConceptModel> {
    const params = new HttpParams().set('typeConceptId', typeConceptId);
    return this._httpClient.get<ConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concept.GetFirstConceptByKeysAsync}`,
      { params: params }
    );
  }

  getLastConceptByKeysAsync(typeConceptId: number): Observable<ConceptModel> {
    const params = new HttpParams().set('typeConceptId', typeConceptId);
    return this._httpClient.get<ConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concept.GetLastConceptByKeysAsync}`,
      { params: params }
    );
  }

  getNextConceptByKeysAsync(typeConceptId: number, code: number): Observable<ConceptModel> {
    const params = new HttpParams().set('typeConceptId', typeConceptId).set('code', code);
    return this._httpClient.get<ConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concept.GetNextConceptByKeysAsync}`,
      { params: params }
    );
  }

  getPreviusConceptByKeysAsync(typeConceptId: number, code: number): Observable<ConceptModel> {
    const params = new HttpParams().set('typeConceptId', typeConceptId).set('code', code);
    return this._httpClient.get<ConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concept.GetPreviusConceptByKeysAsync}`,
      { params: params }
    );
  }

  updateConcept(familyContractModel: ConceptModel): Observable<ConceptModel> {
    return this._httpClient.put<ConceptModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concept.UpdateConcept}`,
      familyContractModel);
  }
}
